import {
  CURRENCY_MANAGER_ACTIVE,
  CURRENCY_MANAGER_ACTIVE_FAIL,
  CURRENCY_MANAGER_ACTIVE_RESET,
  CURRENCY_MANAGER_ACTIVE_SUCCESS,
  CURRENCY_MANAGER_CREATE,
  CURRENCY_MANAGER_CREATE_FAIL,
  CURRENCY_MANAGER_CREATE_RESET,
  CURRENCY_MANAGER_CREATE_SUCCESS,
  CURRENCY_MANAGER_DELETE,
  CURRENCY_MANAGER_DELETE_FAIL,
  CURRENCY_MANAGER_DELETE_RESET,
  CURRENCY_MANAGER_DELETE_SUCCESS,
  CURRENCY_MANAGER_DETAIL,
  CURRENCY_MANAGER_DETAIL_FAIL,
  CURRENCY_MANAGER_DETAIL_RESET,
  CURRENCY_MANAGER_DETAIL_SUCCESS,
  CURRENCY_MANAGER_LIST,
  CURRENCY_MANAGER_LIST_COLUMN,
  CURRENCY_MANAGER_LIST_FAIL,
  CURRENCY_MANAGER_LIST_RESET,
  CURRENCY_MANAGER_LIST_SUCCESS,
  CURRENCY_MANAGER_ROLE_LIST,
  CURRENCY_MANAGER_ROLE_LIST_FAIL,
  CURRENCY_MANAGER_ROLE_LIST_RESET,
  CURRENCY_MANAGER_ROLE_LIST_SUCCESS,
  CURRENCY_MANAGER_UPDATE,
  CURRENCY_MANAGER_UPDATE_FAIL,
  CURRENCY_MANAGER_UPDATE_RESET,
  CURRENCY_MANAGER_UPDATE_SUCCESS,
} from "./actionTypes";

// List CurrencyManager
export const listCurrencyManager = (params = {}) => ({
  type: CURRENCY_MANAGER_LIST,
  payload: { params },
});

export const listCurrencyManagerSuccess = data => ({
  type: CURRENCY_MANAGER_LIST_SUCCESS,
  payload: data,
});

export const listCurrencyManagerFail = error => ({
  type: CURRENCY_MANAGER_LIST_FAIL,
  payload: error,
});

export const resetListCurrencyManager = () => ({
  type: CURRENCY_MANAGER_LIST_RESET,
  payload: {},
});

export const setListCurrencyManagerColumn = (field, value) => ({
  type: CURRENCY_MANAGER_LIST_COLUMN,
  payload: { field, value },
});

// List CurrencyManager Role
export const listCurrencyManagerRole = (params = {}) => ({
  type: CURRENCY_MANAGER_ROLE_LIST,
  payload: { params },
});

export const listCurrencyManagerRoleSuccess = data => ({
  type: CURRENCY_MANAGER_ROLE_LIST_SUCCESS,
  payload: data,
});

export const listCurrencyManagerRoleFail = error => ({
  type: CURRENCY_MANAGER_ROLE_LIST_FAIL,
  payload: error,
});

export const resetListCurrencyManagerRole = () => ({
  type: CURRENCY_MANAGER_ROLE_LIST_RESET,
  payload: {},
});

// Create CurrencyManager
export const createCurrencyManager = userCreate => ({
  type: CURRENCY_MANAGER_CREATE,
  payload: { userCreate },
});

export const createCurrencyManagerSuccess = data => ({
  type: CURRENCY_MANAGER_CREATE_SUCCESS,
  payload: data,
});

export const createCurrencyManagerFail = error => ({
  type: CURRENCY_MANAGER_CREATE_FAIL,
  payload: error,
});

export const resetCreateCurrencyManager = () => ({
  type: CURRENCY_MANAGER_CREATE_RESET,
  payload: {},
});

// Detail CurrencyManager
export const detailCurrencyManager = (userId, params = {}) => ({
  type: CURRENCY_MANAGER_DETAIL,
  payload: { userId, params },
});

export const detailCurrencyManagerSuccess = data => ({
  type: CURRENCY_MANAGER_DETAIL_SUCCESS,
  payload: data,
});

export const detailCurrencyManagerFail = error => ({
  type: CURRENCY_MANAGER_DETAIL_FAIL,
  payload: error,
});

export const resetDetailCurrencyManager = () => ({
  type: CURRENCY_MANAGER_DETAIL_RESET,
  payload: {},
});

// Update CurrencyManager
export const updateCurrencyManager = (userId, data = {}) => ({
  type: CURRENCY_MANAGER_UPDATE,
  payload: { userId, data },
});

export const updateCurrencyManagerSuccess = data => ({
  type: CURRENCY_MANAGER_UPDATE_SUCCESS,
  payload: data,
});

export const updateCurrencyManagerFail = error => ({
  type: CURRENCY_MANAGER_UPDATE_FAIL,
  payload: error,
});

export const resetUpdateCurrencyManager = () => ({
  type: CURRENCY_MANAGER_UPDATE_RESET,
  payload: {},
});

// Delete CurrencyManager
export const deleteCurrencyManager = userId => ({
  type: CURRENCY_MANAGER_DELETE,
  payload: { userId },
});

export const deleteCurrencyManagerSuccess = data => ({
  type: CURRENCY_MANAGER_DELETE_SUCCESS,
  payload: data,
});

export const deleteCurrencyManagerFail = error => ({
  type: CURRENCY_MANAGER_DELETE_FAIL,
  payload: error,
});

export const resetDeleteCurrencyManager = () => ({
  type: CURRENCY_MANAGER_DELETE_RESET,
  payload: {},
});

// Active CurrencyManager
export const activeCurrencyManager = (userId, data = {}) => ({
  type: CURRENCY_MANAGER_ACTIVE,
  payload: { userId, data },
});

export const activeCurrencyManagerSuccess = data => ({
  type: CURRENCY_MANAGER_ACTIVE_SUCCESS,
  payload: data,
});

export const activeCurrencyManagerFail = error => ({
  type: CURRENCY_MANAGER_ACTIVE_FAIL,
  payload: error,
});

export const resetActiveCurrencyManager = () => ({
  type: CURRENCY_MANAGER_ACTIVE_RESET,
  payload: {},
});
